import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MensagensService } from 'max-ng-lib';

import { LinkBaseConhecimento } from './../content/pages/components/models/link-base-conhecimento';
import { GenericServicesMotoristaService } from './generic-services-motorista.service';

@Injectable({
	providedIn: "root",
})
export class LinksBaseConhecimentoService extends GenericServicesMotoristaService {
	constructor(
		private _mensagensService: MensagensService,
		private _httpClient: HttpClient
	) {
		super();
	}

	getMensagensService(): MensagensService {
		return this._mensagensService;
	}

	getHttpClient(): HttpClient {
		return this._httpClient;
	}

	getUrlRecurso(): string {
		return "/link";
	}

	listarPorSolucao() {
		return this.get<LinkBaseConhecimento[]>("/listar");
	}


	async salvarSessionStorage() {
		const links = await this.listarPorSolucao().toPromise();
		sessionStorage.setItem("links", JSON.stringify(links));
	}

	obtenhaSessionStorage(): LinkBaseConhecimento[] {
		return JSON.parse(sessionStorage.getItem("links"));
	}

	getLinkBaseConhecimento(solucao: string): LinkBaseConhecimento {
		const links = this.obtenhaSessionStorage();
		return links.find((link) => link.id === solucao);
	}
}
